import { FC, memo } from 'react';
import { ListTextIconCol } from '@csp/csp-web-ui';
import { BioSampleBaseCol } from '../model/BioSampleBaseCol';

type Props = BioSampleBaseCol & {
  ecode: string;
  label: string;
  visitName?: string;
};

export const PatientCol: FC<Props> = memo(({ label, ecode, visitName, ...props }) => (
  <ListTextIconCol
    title={label}
    text={ecode}
    {...props}
    subLabelProps={{ text: visitName, hideSubLabel: !visitName, ...props.subLabelProps }}
  />
));

PatientCol.displayName = 'PatientCol';
